module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-297.2b23e6e.woff2";